// extracted by mini-css-extract-plugin
export default {"page_layout":"admin_page_layout__jjhof","sidebar":"admin_sidebar__XjPZZ","menu_item":"admin_menu_item__+-gTu","menu_item_selected":"admin_menu_item_selected__0B2PC"};